module.exports = __webpack_public_path__ + "img/island_is_RGB_Hvitt@2x.c49f0be5.png";